// frontend/src/hooks/shareLinkKeys.ts
/**
 * React Query keys for the owner's share links (design 8.6). Everything sits
 * under the 'share-links' root, which lib/queryPersistence.ts never writes to
 * localStorage: each link's URL holds its token.
 */
export const SHARE_LINKS_ROOT = 'share-links';

export const shareLinkKeys = {
  all: [SHARE_LINKS_ROOT] as const,
  tank: (tankId: string) => [SHARE_LINKS_ROOT, tankId] as const,
};
